export const marketingServicePages = [
  {
    slug: 'digital-marketing-strategy',
    path: '/marketing/services/digital-marketing-strategy',
    seoTitle: 'Digital Marketing Strategy | GoldTech Marketing',
    metaDescription: 'Digital marketing strategy that aligns messaging, paid campaigns, and ongoing optimization for measurable growth.',
    eyebrow: 'Strategy services',
    h1: 'Digital Marketing Strategy',
    intro:
      'We build focused marketing strategies that align your messaging, paid campaigns, and organic channels with clear growth goals.',
    sections: [
      {
        title: 'Who it is for',
        items: [
          'Brands that need a clear go-to-market plan',
          'Teams launching new offers or services',
          'Companies looking to improve lead quality from ads'
        ]
      },
      {
        title: 'Problems we solve',
        items: [
          'Unclear positioning and scattered messaging',
          'Low conversion from traffic and campaigns',
          'No unified plan across channels'
        ]
      },
      {
        title: 'Channels and tools',
        items: [
          'Paid media strategy and campaign planning',
          'Channel mix across search, social, and content',
          'Analytics, tracking, and performance dashboards'
        ]
      },
      {
        title: 'Outcomes you can expect',
        items: [
          'A clear plan for growth and execution',
          'Aligned messaging across channels',
          'Ongoing optimization with optional retainer support'
        ]
      }
    ],
    cta: {
      text: 'Build your marketing plan',
      href: '/marketing#contact'
    }
  },
  {
    slug: 'seo-consulting',
    path: '/marketing/services/seo-consulting',
    seoTitle: 'SEO Consulting Services | GoldTech Marketing',
    metaDescription: 'SEO consulting services that improve site structure, content clarity, and performance for sustainable traffic growth.',
    eyebrow: 'SEO services',
    h1: 'SEO Consulting Services',
    intro:
      'We review your website structure, content, and technical performance to improve rankings and conversions.',
    sections: [
      {
        title: 'Who it is for',
        items: [
          'Businesses with stagnant or declining traffic',
          'Teams planning new service pages or site updates',
          'Brands needing a clear SEO and website roadmap'
        ]
      },
      {
        title: 'Problems we solve',
        items: [
          'Pages not ranking for target queries',
          'Weak site structure and internal linking',
          'Content that does not convert'
        ]
      },
      {
        title: 'Channels and tools',
        items: [
          'Technical audits and on-page optimization',
          'Content briefs and keyword mapping',
          'Performance tracking and reporting'
        ]
      },
      {
        title: 'Outcomes you can expect',
        items: [
          'Stronger rankings for priority pages',
          'Improved organic traffic quality',
          'Clear SEO roadmap and execution plan'
        ]
      }
    ],
    cta: {
      text: 'Improve your SEO',
      href: '/marketing#contact'
    }
  },
  {
    slug: 'content-marketing-seo',
    path: '/marketing/services/content-marketing-seo',
    seoTitle: 'Content Marketing, SEO & Web Design | GoldTech Marketing',
    metaDescription: 'Wix web design, content marketing, and SEO that ranks, engages, and converts with an ongoing optimization cadence.',
    eyebrow: 'Content services',
    h1: 'Content Marketing, SEO, and Web Design',
    intro:
      'We design and optimize Wix websites with content that ranks for high-intent queries and turns visitors into leads.',
    sections: [
      {
        title: 'Who it is for',
        items: [
          'Businesses that need consistent content production',
          'Brands launching new Wix service pages or redesigns',
          'Teams that want SEO-focused content strategy'
        ]
      },
      {
        title: 'Problems we solve',
        items: [
          'Blog posts that do not rank',
          'Content with unclear conversion goals',
          'Wix sites that are not built to convert',
          'Social content that does not support the funnel'
        ]
      },
      {
        title: 'Channels and tools',
        items: [
          'Wix web design, UX improvements, and SEO updates',
          'SEO content briefs and on-page optimization',
          'Social content planning and publishing',
          'Performance tracking and updates'
        ]
      },
      {
        title: 'Outcomes you can expect',
        items: [
          'Higher-quality organic traffic',
          'Content that supports conversion',
          'A repeatable content system'
        ]
      }
    ],
    cta: {
      text: 'Launch a content plan',
      href: '/marketing#contact'
    }
  },
  {
    slug: 'brand-development-design',
    path: '/marketing/services/brand-development-design',
    seoTitle: 'Brand Development & Design | GoldTech Marketing',
    metaDescription: 'Brand development and design that define your visual identity, voice, and messaging guidelines.',
    eyebrow: 'Brand services',
    h1: 'Brand Development and Design',
    intro:
      'We build brand systems and brand books that communicate your value, create trust, and support your marketing goals.',
    sections: [
      {
        title: 'Who it is for',
        items: [
          'Businesses rebranding or refining their message',
          'Teams needing stronger visual identity',
          'Founders launching new offers'
        ]
      },
      {
        title: 'Problems we solve',
        items: [
          'Inconsistent branding across channels',
          'Messaging that does not resonate',
          'Outdated or unclear visuals'
        ]
      },
      {
        title: 'Channels and tools',
        items: [
          'Brand strategy and positioning',
          'Brand colors, typography, and logo usage',
          'Messaging frameworks and tone guidance'
        ]
      },
      {
        title: 'Outcomes you can expect',
        items: [
          'A clear brand story and positioning',
          'Consistent visuals and messaging',
          'Improved trust and conversion'
        ]
      }
    ],
    cta: {
      text: 'Strengthen your brand',
      href: '/marketing#contact'
    }
  }
];

export const marketingPlatformPages = [
  {
    slug: 'linkedin-marketing',
    path: '/marketing/linkedin-marketing',
    seoTitle: 'LinkedIn Marketing Agency | GoldTech Marketing',
    metaDescription: 'LinkedIn marketing services for B2B brands. Thought leadership, lead generation, and consistent content.',
    eyebrow: 'LinkedIn',
    h1: 'LinkedIn Marketing Services',
    intro:
      'We help B2B teams grow visibility and generate leads with a LinkedIn strategy that ties into brand, SEO, and web conversion.',
    sections: [
      {
        title: 'Who it is for',
        items: [
          'B2B founders and consultants',
          'Teams building thought leadership',
          'Brands that need consistent lead generation'
        ]
      },
      {
        title: 'What we deliver',
        items: [
          'Digital & social marketing strategy for LinkedIn',
          'Brand messaging and profile positioning',
          'Wix landing pages and SEO-informed content that converts'
        ]
      },
      {
        title: 'Outcomes you can expect',
        items: [
          'Stronger visibility and credibility',
          'Consistent inbound interest from the right audience',
          'Traffic routed to conversion-ready pages'
        ]
      }
    ],
    cta: {
      text: 'Grow on LinkedIn',
      href: '/marketing#contact'
    }
  },
  {
    slug: 'instagram-for-business',
    path: '/marketing/instagram-for-business',
    seoTitle: 'Instagram Marketing for Business | GoldTech Marketing',
    metaDescription: 'Instagram marketing for business with content planning, engagement strategy, and performance tracking.',
    eyebrow: 'Instagram',
    h1: 'Instagram for Business',
    intro:
      'We build Instagram strategies that grow engagement and connect your content to conversion-focused web experiences.',
    sections: [
      {
        title: 'Who it is for',
        items: [
          'Brands that want stronger social engagement',
          'Teams needing a consistent content cadence',
          'Businesses looking to improve social conversions'
        ]
      },
      {
        title: 'What we deliver',
        items: [
          'Digital & social marketing strategy for Instagram',
          'Brand design guidance and content direction',
          'Wix web design, SEO updates, and funnel alignment'
        ]
      },
      {
        title: 'Outcomes you can expect',
        items: [
          'Consistent engagement growth',
          'A cohesive brand presence across platforms',
          'Social traffic that converts into leads'
        ]
      }
    ],
    cta: {
      text: 'Grow on Instagram',
      href: '/marketing#contact'
    }
  },
  {
    slug: 'google-ads-ppc-management',
    path: '/marketing/google-ads-ppc-management',
    seoTitle: 'Google Ads & PPC Management | GoldTech Marketing',
    metaDescription: 'Google Ads and PPC management that covers strategy, setup, optimization, and performance reporting.',
    eyebrow: 'Paid media',
    h1: 'Google Ads and PPC Management',
    intro:
      'We manage Google Ads campaigns end-to-end with landing pages, SEO hygiene, and brand alignment that improve conversion rates.',
    sections: [
      {
        title: 'Who it is for',
        items: [
          'Businesses seeking predictable lead flow',
          'Teams with underperforming ads',
          'Brands that need clearer ROI tracking'
        ]
      },
      {
        title: 'What we deliver',
        items: [
          'Digital marketing strategy and campaign execution',
          'Wix landing pages, content, and SEO readiness',
          'Conversion optimization and performance reporting'
        ]
      },
      {
        title: 'Outcomes you can expect',
        items: [
          'Improved conversion rates',
          'Lower cost per lead',
          'Clear ROI reporting'
        ]
      }
    ],
    cta: {
      text: 'Improve paid performance',
      href: '/marketing#contact'
    }
  }
];

export const marketingIndustryPages = [
  {
    slug: 'for-coaches',
    path: '/marketing/for-coaches',
    seoTitle: 'Marketing for Coaches | GoldTech Marketing',
    metaDescription: 'Marketing for coaches that builds visibility, clarifies messaging, and drives more qualified leads.',
    eyebrow: 'For coaches',
    h1: 'Marketing for Coaches',
    intro:
      'We help coaches grow with clearer messaging, consistent content, and lead generation systems.',
    sections: [
      {
        title: 'Common challenges',
        items: [
          'Inconsistent content and weak engagement',
          'No clear positioning or offer messaging',
          'Limited lead flow from marketing efforts'
        ]
      },
      {
        title: 'What we deliver',
        items: [
          'Digital & social marketing strategy',
          'Wix web design, content, and SEO improvements',
          'SEO consulting for core offers',
          'Brand development and design guidance'
        ]
      },
      {
        title: 'Channels we focus on',
        items: [
          'LinkedIn and Instagram content',
          'Conversion-focused landing pages',
          'Lead magnets and nurture sequences'
        ]
      }
    ],
    cta: {
      text: 'Grow your coaching business',
      href: '/marketing#contact'
    }
  },
  {
    slug: 'for-consultants',
    path: '/marketing/for-consultants',
    seoTitle: 'Marketing for Consultants | GoldTech Marketing',
    metaDescription: 'Marketing for consultants that builds authority, strengthens positioning, and drives inbound leads.',
    eyebrow: 'For consultants',
    h1: 'Marketing for Consultants',
    intro:
      'We help consultants build authority, refine their message, and create reliable lead pipelines.',
    sections: [
      {
        title: 'Common challenges',
        items: [
          'Unclear differentiation in a crowded market',
          'Inconsistent content or outreach',
          'Low-quality leads'
        ]
      },
      {
        title: 'What we deliver',
        items: [
          'Digital & social marketing strategy',
          'Wix web design, content, and SEO improvements',
          'SEO consulting for niche services',
          'Brand development and design systems'
        ]
      },
      {
        title: 'Channels we focus on',
        items: [
          'LinkedIn thought leadership and SEO',
          'Conversion-ready service pages',
          'Email nurture and lead magnets'
        ]
      }
    ],
    cta: {
      text: 'Build consistent inbound leads',
      href: '/marketing#contact'
    }
  },
  {
    slug: 'for-real-estate-teams',
    path: '/marketing/for-real-estate-teams',
    seoTitle: 'Marketing for Real Estate Teams | GoldTech Marketing',
    metaDescription: 'Marketing for real estate teams that improves lead quality, follow-up, and local visibility.',
    eyebrow: 'For real estate',
    h1: 'Marketing for Real Estate Teams',
    intro:
      'We build marketing systems that generate qualified leads and support timely follow-up for real estate teams.',
    sections: [
      {
        title: 'Common challenges',
        items: [
          'Leads that are not qualified',
          'Low local visibility in search',
          'No consistent content or campaigns'
        ]
      },
      {
        title: 'What we deliver',
        items: [
          'Digital & social marketing strategy',
          'Wix web design, content, and SEO improvements',
          'SEO consulting for local visibility',
          'Brand development and design for listings'
        ]
      },
      {
        title: 'Channels we focus on',
        items: [
          'Local SEO and Google Business Profile',
          'Paid search and social ads',
          'Follow-up and CRM nurture'
        ]
      }
    ],
    cta: {
      text: 'Boost your real estate leads',
      href: '/marketing#contact'
    }
  },
  {
    slug: 'for-speakers',
    path: '/marketing/for-speakers',
    seoTitle: 'Marketing for Speakers | GoldTech Marketing',
    metaDescription: 'Marketing for speakers that builds authority, increases inquiries, and supports booking growth.',
    eyebrow: 'For speakers',
    h1: 'Marketing for Speakers',
    intro:
      'We help speakers grow their authority and booking inquiries with clear messaging and consistent content.',
    sections: [
      {
        title: 'Common challenges',
        items: [
          'Low visibility in search and social',
          'Inconsistent content publishing',
          'Unclear differentiation'
        ]
      },
      {
        title: 'What we deliver',
        items: [
          'Digital & social marketing strategy',
          'Wix web design, content, and SEO improvements',
          'SEO consulting for speaker topics',
          'Brand development and design for authority'
        ]
      },
      {
        title: 'Channels we focus on',
        items: [
          'SEO and content marketing',
          'LinkedIn and Instagram',
          'Booking funnels and follow-up'
        ]
      }
    ],
    cta: {
      text: 'Increase speaking inquiries',
      href: '/marketing#contact'
    }
  }
];

export const getMarketingPageBySlug = (pages, slug) =>
  pages.find((page) => page.slug === slug);
